import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { InputFieldSelectionBaseComponent } from './input-field-selection-base.component';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { ReactiveFormsModule } from '@angular/forms';
import { StyleDirective } from '@ngbracket/ngx-layout';
import { flexColumnStyle, flexStyle } from '@mng/mng-ts-helpers';
import { MatError } from '@angular/material/form-field';

@Component({
  selector: 'mng-inputfield-radio',
  imports: [MatRadioGroup, ReactiveFormsModule, MatRadioButton, StyleDirective, MatError],
  template: `
    <mat-radio-group [id]="field().id" [formControl]="field().control" [style]="groupStyle()" [ngStyle]="ngStyle()">
      @for (option of options(); track option.name) {
        <mat-radio-button [value]="option.value">
          <div
            class="text"
            style="font-weight: 300; white-space: normal;"
            [innerHTML]="getRealOptionLabel(option)"
          ></div>
        </mat-radio-button>
      }
    </mat-radio-group>
    @if (showError() && hasErrors) {
      <mat-error style="font-size: small"> {{ validationMessage }} </mat-error>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InputFieldRadioComponent extends InputFieldSelectionBaseComponent {
  readonly groupRendering = input<'vertical' | 'horizontal'>('horizontal');

  readonly groupStyle = computed<string>(() =>
    this.groupRendering() === 'horizontal' ? flexStyle() : flexColumnStyle('0')
  );
}
